<template>
    <div class="container">
        <div class="gk-admin-portal row">
        <div class="icon-logo" alt="Home"></div>
        <h2>EIS Web Portal</h2>
    </div>
    <div class=" row justify-content-center">
        <div class="card w-50 login-panel">
          <div class="card-body">

            <h1>403 - Forbidden</h1>
            <br/>
            <br />
            <h2>You do not have the permissions to view this page.</h2>

            </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {};
        }
    };
</script>


<style lang="scss" scoped>
@import "../css/constants";

//Reset row
.row {
  margin: 0;
}
.gk-admin-portal {
  width: 52vw;
    display: flex;
    margin-top: -4rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    /* Administrator Portal: */
    font-family: Hind Semibold;
    font-size: $p20;
  }
}
.icon-logo{
  background-size: 7rem 7rem;
  width: 7rem;
  height: 7rem;
  margin: auto;
  margin-bottom: $p16;
  background-repeat: no-repeat;
}

.version-number {
  /* Rectangle: */
  font-size: $p14;
  padding: 6px 8px;
    padding-top: 8px;
    margin-top: $p16;
  color: $gray5;
  background: $gray2;
  border: 1px solid $gray4;
  border-radius: 4px;
}

.container {
  display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;
    width: 100vw;
  background:$gray2;
}
input {
  width: 300px;
  padding-top: 10px;
}
.login-panel {
  width: 48vw;
  height: 100vh;
  justify-content: center;
  border: none;
  box-shadow: none;
  border-radius: 0;
  -webkit-clip-path: polygon(14% 0%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(14% 0%, 100% 0, 100% 100%, 0% 100%);

  /* Rectangle 35: */
  background-image: linear-gradient(-180deg, #56ccf2 0%, #2f80ed 100%);
  
  .card-body {

    text-align: center;
    align-self: center;
    width: 300px;
    margin-left: $p52;
    margin-top: -3rem;
    color: white;
    justify-content: space-between;

    .form-group {
      margin-top: $p16;
      margin-bottom: $p24;
    }

    a {
      color: white;
      font-size: $p14;
      font-family: 'Hind Semibold';
      &:hover {
        color: white;
        cursor: pointer;
      }
    }

    h1{
        font-size: 40px;
        
    }

    h2{
        color: white;
        font-size: 20px;
        line-height: 30px;
    }
  }
  .login-instruction {
    font-size: $p12;
    color: white;
    font-family: 'Hind Regular';
  }
}
.col-sm-10 {
  width: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
}

.btn-primary {
  border-radius: 100px;
    color: #243c98;
    padding: 9px $p40;
    padding-top: $p10;
  padding-left: $p24;
  padding-right: $p56;
    background: white;
    font-family: 'Hind Semibold';
    border: none;
  background-image: url('../assets/sign-in-arrow.svg');
  background-size: $p20;
  background-position: 82px 11px;
  background-repeat: no-repeat;
  &:focus {
    box-shadow: none;
    outline: none;
  }
  &:active {
    background-color: white;
    color: $gkred;
  }
}

@media only screen and (max-width: 768px) {
  .gk-admin-portal{
    width: 100vw;
    height: 40vh;
    .icon-logo{
      margin-top: 5vh;
      margin-bottom: 10px;
    }
  }
  .container{
    display: flex;
    flex-direction: column;
  }

  .row{
    .login-panel{
      height: 60vh;
      width: 100vw;
      -webkit-clip-path: none;
      clip-path: none;

      .btn-primary{
        background-image: none;
      }
    }
  }
}

@media only screen and (max-width: 468px) {
  .gk-admin-portal{
    .icon-logo{
      background-size: 10rem 10rem;
      width: 10rem;
      height: 10rem;
    }
  }

  .row{
    .login-panel{
      h1{
        font-size: 30px;
        margin-bottom: 0px;
      }

      .card-body{
        margin-left: 0px;
      }

      input{
        width: 250px;
      }

      .form-container{
        padding-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Forbidden.vue